<template>
    <div>
        <Header />
        <section class="section-b-space" v-if="userInfo">
            <div>
                <h3>My Account</h3>
                <v-card class="mt-4" style="background-color: #ffffff">
                    <b-row
                        class="pt-4 mr-4"
                        align-h="end"
                        v-if="userInfo.status && userInfo.category === 'SELLER'"
                    >
                        <b-col md="auto">
                            <b-row align-v="center">
                                <p
                                    class="m-0 p-0 mr-1 mt-2"
                                    style="font-size: 15px"
                                >
                                    {{
                                        !userInfo.isOffline
                                            ? "Online"
                                            : "Offline"
                                    }}
                                </p>
                                <c-switch
                                    @change="updateOfflineStatus"
                                    v-model="userInfo.isOffline"
                                    :inverse="true"
                                    color="primary"
                                    class="mx-2 mt-2"
                                    variant="pill"
                                >
                                </c-switch>
                            </b-row>
                        </b-col>
                        <b-col md="auto">
                            <b>Account Status : {{ userInfo.status }}</b>
                        </b-col>
                    </b-row>
                    <b-row class="m-2">
                        <b-col md="4" class="mt-4">
                            <v-hover v-slot="{ hover }" close-delay="200">
                                <v-card
                                    :elevation="hover ? 16 : 2"
                                    :class="{ 'on-hover': hover }"
                                    class="mx-auto Account-card"
                                >
                                    <a
                                        href="javascript:void(0)"
                                        @click="
                                            $router.push({
                                                path: '/myaccount/viewprofile',
                                            })
                                        "
                                    >
                                        <h4 class="m-0">My Profile</h4>
                                        <i class="icon fas fa-angle-right"></i>
                                    </a>
                                    <p class="mt-2">
                                        To view / edit your profile info
                                    </p>
                                </v-card>
                            </v-hover>
                        </b-col>
                        <b-col md="4" class="mt-4">
                            <v-hover v-slot="{ hover }" close-delay="200">
                                <v-card
                                    :elevation="hover ? 16 : 2"
                                    :class="{ 'on-hover': hover }"
                                    class="mx-auto Account-card"
                                >
                                    <a
                                        href="javascript:void(0)"
                                        @click="
                                            $router.push({
                                                path: '/myaccount/subscriptionseller',
                                            })
                                        "
                                    >
                                        <h4 class="m-0">My Subscription</h4>
                                        <i class="icon fas fa-angle-right"></i>
                                    </a>
                                    <p class="mt-2">
                                        To view your subscription plan
                                    </p>
                                </v-card>
                            </v-hover>
                        </b-col>

                        <b-col md="4" class="mt-4">
                            <v-hover v-slot="{ hover }" close-delay="200">
                                <v-card
                                    :elevation="hover ? 16 : 2"
                                    :class="{ 'on-hover': hover }"
                                    class="mx-auto Account-card"
                                >
                                    <a
                                        href="javascript:void(0)"
                                        @click="
                                            $router.push({
                                                path: '/myaccount/paymentinfo',
                                            })
                                        "
                                    >
                                        <h4 class="m-0">My Payment</h4>
                                        <i class="icon fas fa-angle-right"></i>
                                    </a>
                                    <p class="mt-2">
                                        To view your payment information
                                    </p>
                                </v-card>
                            </v-hover>
                        </b-col>
                    </b-row>
                    <b-row class="m-2">
                        <b-col md="4">
                            <v-hover v-slot="{ hover }" close-delay="200">
                                <v-card
                                    :elevation="hover ? 16 : 2"
                                    :class="{ 'on-hover': hover }"
                                    class="mx-auto Account-card"
                                >
                                    <a
                                        href="javascript:void(0)"
                                        @click="
                                            $router.push({
                                                path: '/myaccount/my-invoice',
                                            })
                                        "
                                    >
                                        <h4 class="m-0">My Invoice</h4>
                                        <i class="icon fas fa-angle-right"></i>
                                    </a>
                                    <p class="mt-2">
                                        To view all your invoices
                                    </p>
                                </v-card>
                            </v-hover>
                        </b-col>
                        <b-col md="4">
                            <v-hover v-slot="{ hover }" close-delay="200">
                                <v-card
                                    :elevation="hover ? 16 : 2"
                                    :class="{ 'on-hover': hover }"
                                    class="mx-auto Account-card"
                                >
                                    <a
                                        href="javascript:void(0)"
                                        @click="
                                            $router.push({
                                                path: '/myaccount/walletstatement',
                                            })
                                        "
                                    >
                                        <h4 class="m-0">My Statement</h4>
                                        <i class="icon fas fa-angle-right"></i>
                                    </a>
                                    <p class="mt-2">
                                        To view/download your statements
                                    </p>
                                </v-card>
                            </v-hover>
                        </b-col>
                        <b-col md="4">
                            <v-hover v-slot="{ hover }" close-delay="200">
                                <v-card
                                    :elevation="hover ? 16 : 2"
                                    :class="{ 'on-hover': hover }"
                                    class="mx-auto Account-card"
                                >
                                    <a
                                        href="javascript:void(0)"
                                        @click="
                                            $router.push({
                                                path: '/myaccount/delivery-preference',
                                            })
                                        "
                                    >
                                        <h4 class="m-0">Delivery Preference</h4>
                                        <i class="icon fas fa-angle-right"></i>
                                    </a>
                                    <p class="mt-2">
                                        Make your delivery preferences
                                    </p>
                                </v-card>
                            </v-hover>
                        </b-col>
                    </b-row>

                    <b-row
                        class="m-2"
                        v-if="this.$currentUserData.category == 'SELLER'"
                    >
                        <b-col md="4">
                            <v-hover v-slot="{ hover }" close-delay="200">
                                <v-card
                                    :elevation="hover ? 16 : 2"
                                    :class="{ 'on-hover': hover }"
                                    class="mx-auto Account-card"
                                >
                                    <a
                                        href="javascript:void(0)"
                                        @click="
                                            $router.push({
                                                path: `/myaccount/customer-rateing/${userInfo._id}`,
                                            })
                                        "
                                    >
                                        <h4 class="m-0">Customer Rating</h4>
                                        <i class="icon fas fa-angle-right"></i>
                                    </a>

                                    <p class="mt-2">
                                        Notify Seller Only On Order
                                    </p>
                                </v-card>
                            </v-hover>
                        </b-col>
                        <b-col md="4">
                            <v-hover v-slot="{ hover }" close-delay="200">
                                <v-card
                                    :elevation="hover ? 16 : 2"
                                    :class="{ 'on-hover': hover }"
                                    class="mx-auto Account-card"
                                >
                                    <a
                                        href="javascript:void(0)"
                                        @click="
                                            $router.push({
                                                path: `/setup/policy`,
                                            })
                                        "
                                    >
                                        <h4 class="m-0">
                                            Refund & Cancellation Policy
                                        </h4>
                                        <i class="icon fas fa-angle-right"></i>
                                    </a>

                                    <p class="mt-2">
                                        Notify Seller Only On Order
                                    </p>
                                </v-card>
                            </v-hover>
                        </b-col>
                    </b-row>
                    <b-row
                        class="m-2"
                        v-if="
                            this.$currentUserData.category != 'SELLER' &&
                            this.$currentUserData.category != 'DEALER' &&
                            this.$currentUserData.category != 'DISTRIBUTOR'
                        "
                    >
                        <b-col md="4">
                            <v-hover v-slot="{ hover }" close-delay="200">
                                <v-card
                                    :elevation="hover ? 16 : 2"
                                    :class="{ 'on-hover': hover }"
                                    class="mx-auto Account-card"
                                >
                                    <a
                                        href="javascript:void(0)"
                                        @click="
                                            $router.push({
                                                path: 'myaccount/order-preference',
                                            })
                                        "
                                    >
                                        <h4 class="m-0">Order Preference</h4>
                                        <i class="icon fas fa-angle-right"></i>
                                    </a>
                                    <p class="mt-2">
                                        Notify Seller Only On Order
                                    </p>
                                </v-card>
                            </v-hover>
                        </b-col>
                    </b-row>
                </v-card>
            </div>
        </section>
        <Footer class="mt-5" />
    </div>
</template>
<script>
import { mapGetters } from "vuex";
import { Switch as cSwitch } from "@/components/Switch";

export default {
    components: {
        cSwitch,
    },
    computed: {
        ...mapGetters({
            userInfo: "profileUpdate/GetmeTenant",
        }),
    },
    mounted() {
        this.$store.dispatch("profileUpdate/fetchmeTenant");
    },
    methods: {
        async updateOfflineStatus(event) {
            try {
                await this.$store.dispatch("partner/offlinePartner", {
                    id: this.userInfo._id,
                    data: {
                        isOffline: !this.userInfo.isOffline,
                    },
                });
                this.$store.commit("profileUpdate/setmeTenant", {
                    ...this.userInfo,
                    isOffline: !this.userInfo.isOffline,
                });
            } catch (err) {
                // failed
            }
        },
    },
};
</script>
<style scoped>
.Account-card {
    height: 80px;
    background-color: #ffffff;
    padding: 18px;
    cursor: pointer;
}
p {
    font-size: 13px;
}
h4 {
    color: var(--secondary);
    font-size: 18px;
}
.icon {
    position: absolute;
    left: 94.79%;
    right: 59.79%;
    top: 11.66%;
    bottom: 76.17%;
    font-size: 20px;
    color: var(--secondary);
    float: right;
}
</style>
